/* eslint-disable jsx-a11y/alt-text */
import "./DealsCard.css";
import React, { Fragment, useEffect, useMemo, useState } from "react";

// MUI Start
import { Avatar } from "@mui/material";
// MUI End

// Functions Start
import { stringAvatar } from "../../../helpers/stringAvatar";
import { intervalToDuration } from "date-fns";
// import { formatPriceToEasyFormat } from "../../../helpers/formatPrice";
// Functions End

// Controllers Start
import GetSingleAgent from "../../../controllers/agents/GetSingleAgent";
import GetAdmin from "../../../controllers/admin/GetAdmin";
import GetSingleLead from "../../../controllers/leads/GetSingleLead";
import GetProperty from "../../../controllers/properties/getProperty";
import FormatPriceNumeral from "../../../helpers/FormatPriceNumeral";
import FormatPriceVerbal from "../../../helpers/FormatPriceVerbal";
import getSettings from "../../../controllers/settings/getSettings";
// Controllers End

const DealsCard = ({
  // divId,
  // openId,
  onClick,
  key,
  id = "",
  agent = "",
  // comments = "",
  status = "",
  interest = "",
  lead = "",
  property = "",
  createdAt = "",
  // transaction = "",
  // name = "",
  dealPrice = "",
  thumbnail,
  // CurrencySettings,
  openSearch,
}) => {
  status = status === null ? "" : status;
  interest = interest === null ? "" : interest;
  const statusUppercase = status.charAt(0).toUpperCase() + status.substring(1);
  const interestUppercase =
    interest.charAt(0).toUpperCase() + interest.substring(1);

  // useState States Start
  const [agentData, setAgentData] = useState(null);
  const [leadData, setLeadData] = useState(null);
  const [propertyData, setPropertyData] = useState(null);
  // const [Thumbnail, setThumbnail] = useState(null);

  // const [RequestingPropertiers, setRequestingPropertiers] = useState(true);
  // const [Properties, setProperties] = useState(null);
  const [Duration, setDuration] = useState("");
  // useState States End

  useMemo(() => {
    const { years, months, days, hours, minutes, seconds } = intervalToDuration(
      {
        start: openSearch ? new Date(createdAt) : new Date(createdAt?.toDate()),
        // start: new Date(createdAt)
        //   .toLocaleString("en-GB", {
        //     year: "numeric",
        //     month: "short",
        //     day: "numeric",
        //   })
        //   .split(" ")
        //   .slice(0, 4)
        //   .join(" "),
        end: new Date(),
      }
    );
    setDuration(
      years !== 0
        ? `${years} year${years !== 1 ? "s" : ""}`
        : months !== 0
        ? `${months} month${months !== 1 ? "s" : ""}`
        : days !== 0
        ? `${days} day${days !== 1 ? "s" : ""}`
        : hours !== 0
        ? `${hours} hour${hours !== 1 ? "s" : ""}`
        : minutes !== 0
        ? `${minutes} minute${minutes !== 1 ? "s" : ""}`
        : `${seconds} second${seconds !== 1 ? "s" : ""}`
    );
  }, [createdAt, openSearch]);

  //  CurrencyState start
  const [mCurrencySettings, setMCurrencySettings] = useState({});
  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setMCurrencySettings(settings);
    }
    fetchData();
  }, []);

  // CurrencyState Ends

  // Single Agent useEffect Start
  useEffect(() => {
    async function fetchData() {
      const singleAgentData = await GetSingleAgent(agent);

      const objectKeys = Object.keys(singleAgentData).length;
      const agentFinalData =
        objectKeys === 1 ? await GetAdmin() : singleAgentData;

      setAgentData(agentFinalData);
    }
    fetchData();
  }, [agent]);
  // Single Agent useEffect End

  // Single Lead useEffect Start
  useEffect(() => {
    async function fetchData() {
      const singleLeadData = await GetSingleLead(lead);
      setLeadData(singleLeadData);
    }
    fetchData();
  }, [lead]);
  // Single Lead useEffect End

  // Single Property useEffect Start
  useEffect(() => {
    async function fetchData() {
      const singlePropertyData = await GetProperty(property);
      setPropertyData(singlePropertyData);
    }
    fetchData();
  }, [property]);
  // Single Property useEffect End

  return (
    <Fragment>
      <div className="deals-listing-card" key={key} onClick={onClick}>
        <div className="listing-card-header">
          <div className="left">
            <div className="user-avatar">
              {/* <img src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8YXZhdGFyc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" /> */}
              <Avatar {...stringAvatar(leadData?.name)} />
            </div>
            <div className="custom-header-content">
              <div className="name">{leadData?.name}</div>
              <div className="tag">
                Interested in
                {interest === "buy"
                  ? " Buying"
                  : interest === "sale"
                  ? " Selling"
                  : " Renting"}
                {` a ${propertyData?.propertySubType}`}
              </div>
            </div>
          </div>
          <div className="right">
            <div>
              {" "}
              <span
                className={
                  status === "open"
                    ? "open-status-badge"
                    : status === "won"
                    ? "won-status-badge"
                    : "lost-status-badge"
                }
              >
                {statusUppercase}
              </span>
              <span className="interset-status-badge ml-1">
                {interestUppercase}
              </span>
            </div>
          </div>
        </div>

        <div className="listing-card-body">
          <div className="left">
            {thumbnail ? (
              <img src={thumbnail && thumbnail} className="image" />
            ) : (
              <svg
                width="61"
                height="56"
                viewBox="0 0 61 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_1395_1924)">
                  <rect
                    x="4"
                    y="3"
                    width="52.3636"
                    height="48"
                    rx="5"
                    fill="#4C3CA6"
                  />
                </g>
                <path
                  d="M16 38V24.6842L25.0625 18.6316L34.125 24.6842V38H28.0833V29.5263H22.0417V38H16ZM45 15V38H36.5417V23.3889L35.3333 22.59V19.8421H32.9167V20.9679L28.0833 17.7479V15H45ZM41.375 29.5263H38.9583V31.9474H41.375V29.5263ZM41.375 24.6842H38.9583V27.1053H41.375V24.6842ZM41.375 19.8421H38.9583V22.2632H41.375V19.8421Z"
                  fill="white"
                />
                <defs>
                  <filter
                    id="filter0_d_1395_1924"
                    x="0"
                    y="0"
                    width="60.3633"
                    height="56"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_1395_1924"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_1395_1924"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            )}
          </div>
          <div className="right">
            <div className="title">
              {propertyData && propertyData.propertyTitle}
            </div>
            <div className="address">
              {propertyData && propertyData.address}
            </div>
            <div className="currency">
              {dealPrice &&
                `${
                  mCurrencySettings?.currency ? mCurrencySettings?.currency : ""
                } ${
                  mCurrencySettings.currencyFormat === "numeral"
                    ? FormatPriceNumeral(dealPrice)
                    : FormatPriceVerbal(dealPrice)
                }
                
              `}
            </div>
          </div>
        </div>

        <div className="card-divider">
          <hr />
        </div>
        <div className="listing-card-footer">
          <div className="left">
            <h5
              className="footer-text"
              style={{
                marginTop: 10,
              }}
            >
              <i className="ti-time mr-1"></i>
              {`${Duration} ago`}
            </h5>
          </div>
          {agentData && (
            <div className="right">
              <div className="user-avatar">
                {/* <img src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8YXZhdGFyc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" /> */}
                <Avatar {...stringAvatar(agentData?.name)} />
              </div>
              <div className="footer-text">{agentData?.name}</div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default DealsCard;
